module.exports = __webpack_public_path__ + "assets/fc06c0ea279690797b2eb7f8f7e7cae8.svg";